<div class="provision-button">
    <ng-content></ng-content>
</div>
